<template>
  <div style="width:100%;height:100%;overflow-y: scroll;">
    <div class="content-header" style="margin-top:5px;">
      <div class="left"></div>
      <div class="right">
        <div class="right" style="float:right;">
          <Button type="primary" @click="printQrCode" style="margin-right:10px;">打印</Button>
          <!-- <Button type="primary" @click="printQrCode" style="margin-right:10px;">调整</Button> -->
        </div>
      </div>
    </div>
    <!-- width: 842px;  -->
    <div id="QrCodePrint" style="width: 842px;margin: 0 auto; overflow:hidden;background:#eeeeee;">
      <div style="height:32.5px;"></div>
      <div
        class="item"
        v-for="(item,key) in list"
        :key="key"
        style="width: calc(50% - 15px);height:255px;overflow:hidden;overflow:hidden;float:left;text-align:center;position: relative;border:1px solid #000;padding:0;margin-left:7.5px;"
      >
        <!-- :style="{marginLeft:key % 2 === 0 ? '12.5px' : '7.5px'}" -->
        <img :src="bg" alt class="bg" style="width:100%;" />
        <div
          :ref="`qrcode${item.id}`"
          :id="`qrcode${item.id}`"
          style="position: absolute;top:127px;right:7%;background:#FFF;padding:5px;"
        ></div>
        <p style="position: absolute;top:217px;right:8%;">打开微信扫一扫</p>
        <p style="position: absolute;top:237px;right:11%;">{{item.code_no}}</p>
        <div
          class="tel"
          style="color:#FFFFFF;height:30px;position: absolute;top:137px;z-index:100;width:60%;text-align:left;padding-left:40px;"
        >
          <img
            :src="icon"
            alt
            class="icon"
            style="width:25px;height:25px;display:inline-block;vertical-align: middle;"
          />
          <span
            style="font-size:18px;color:#FFFFFF;margin-left:5px;display:inline-block;vertical-align: middle;margin-top:5px;"
          >{{agent.service_tel || agent.contacts_tel}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QRCode from 'qrcodejs2'
import config from '../../../config/index'
export default {
  data () {
    return {
      list: [],
      bg: require('../../../assets/images/print_code_bg.png'),
      icon: require('../../../assets/images/tel_icon.png'),
      page: {
        p: 0,
        l: 8,
        type: 0,
        ids: ''
      }
    }
  },
  methods: {
    ...mapActions(['GetMeterQrCode']),
    initQrcode () {
      this.list.map((item, key) => {
        item.select = false
        try {
          let Dom = document.getElementById(
            this.selectTableIndex === 1
              ? `qrcode_new${item.id}`
              : `qrcode${item.id}`
          )
          Dom.innerHTML = ''
          let qrcode = new QRCode(Dom, {
            // text: config.baseUrl.pro + "/wechat/meterreader/home?code_no=" + item.code_no,
            text:
              'http://153c459s25.iok.la/wechat/meterreader/home?code_no=' +
              item.code_no,
            width: 80,
            height: 80,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
          })
        } catch (error) {
          console.log(error)
        }
      })
    },
    getData () {
      this.GetMeterQrCode(this.page).then(res => {
        this.list = res.data
        this.total = res.total
        setTimeout(() => {
          this.initQrcode()
        }, 300)
      })
    },
    printQrCode () {
      const oldHtml = document.body.innerHTML
      const newstr = document.getElementById('QrCodePrint').innerHTML
      document.body.innerHTML = newstr
      window.print()
      document.body.innerHTML = oldHtml
      window.location.reload()
    }
  },
  mounted () {
    this.getData()
  },
  created () {
    this.page.ids = this.$route.query.ids || ''
    this.page.type = this.$route.query.type || 0
  },
  computed: mapGetters({ agent: 'agent' })
}
</script>

<style lang="less" scoped>
@import "./index.less";
/* #QrCodePrint {
  width: 842px;
  height: 100%;
  margin: 0 auto;
  background: #eee;
} */
</style>
